import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import App from './App';
import './styles/global.css';

/**
 * Main entry point for the React Story Player
 * This file is loaded by Blazor via interop
 */

let root: Root | null = null;

/**
 * Mount the React app
 * Called by Blazor's ReactInterop.InitializeReactAppAsync()
 */
function mountReactApp(containerId: string) {
  console.log('[React] Mounting Story Player to:', containerId);

  const container = document.getElementById(containerId);

  if (!container) {
    console.error(`[React] Container element #${containerId} not found`);
    return;
  }

  // Create React root
  root = createRoot(container);

  // Render the App
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  console.log('[React] Story Player mounted successfully');
}

/**
 * Unmount the React app
 */
function unmountReactApp() {
  console.log('[React] Unmounting Story Player');

  if (root) {
    root.unmount();
    root = null;
  }
}

/**
 * Expose React app to global scope for Blazor interop
 */
if (typeof window !== 'undefined') {
  (window as any).ReactStoryPlayer = {
    mount: mountReactApp,
    unmount: unmountReactApp,
  };

  console.log('[React] Story Player ready for initialization');
}

export { mountReactApp, unmountReactApp };
